/** Performance stats domain query segments */
export const PerfStatsQueryKeys = {
  performance: {
    list: (payload: unknown) => ['/reporting/performance-stats', payload] as const,
  },
  taskFilters: {
    all: ['task-filters'] as const,
  },
};
